<template>
  <MenuPane class="TopMenuPane" :isShowing="openMenus.includes('TOP')">
    <TopMenuEntry v-for="item in content.topLevelItems"
      :key="item.title"
      :content="item"
      :openMenus="openMenus"
    />
    <!-- 'data-testing-target' attribute is used in Ghost Inspector tests -->
    <CtaButton
      class="--dark-blue demoCta"
      :text="content.cta.text"
      @click="triggerCta"
      data-testing-target="siteNavCtaButtonMobile"
    />
    <TopMenuEntry
      v-if="content.login"
      class="login"
      :content="content.login"
      :openMenus="openMenus"
    />
  </MenuPane>
</template>

<script>
import MenuPane from './MenuPane.vue'
import TopMenuEntry from './TopMenuEntry.vue'

export default {
  components: {
    MenuPane,
    TopMenuEntry,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    openMenus: {
      type: Array,
      required: true,
    },
    triggerCta: {
      type: Function,
      required: true,
    },
  },
}
</script>

<style scoped>
.TopMenuPane {
  background-color: white;
  padding-right: var(--gutter-width);
  padding-bottom: var(--spacing-11);
  padding-left: var(--spacing-10);
}
.demoCta {
  margin-top: var(--spacing-13);
}
.login {
  margin-top: var(--spacing-17);
}
</style>
